export default "__VITE_PUBLIC_ASSET__a112596a__"